var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopyFlat = function SvgCopyFlat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.928 1.62H7.273A2.45 2.45 0 0 0 4.83 4.071v.759h-.767A2.45 2.45 0 0 0 1.62 7.281v12.648a2.45 2.45 0 0 0 2.443 2.451h12.656a2.453 2.453 0 0 0 2.451-2.451v-.759h.759a2.453 2.453 0 0 0 2.451-2.451V4.071c0-1.351-1.1-2.451-2.451-2.451zm-2.259 18.309a.95.95 0 0 1-.951.951H4.062a.95.95 0 0 1-.943-.951V7.281a.95.95 0 0 1 .943-.951h12.656c.524 0 .951.427.951.951v12.648m3.21-3.21a.953.953 0 0 1-.951.951h-.759V7.281a2.453 2.453 0 0 0-2.451-2.451H6.329v-.759a.95.95 0 0 1 .943-.951h12.655a.95.95 0 0 1 .951.951v12.648z"
  })));
};
export default SvgCopyFlat;